import React from "react";
import { TailSpin } from "react-loader-spinner";

const Spinner = (props) => {
  const spinnerStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "30px",
  };

  return (
    <div style={spinnerStyles}>
      <TailSpin color="#E10A0A" {...props} />
    </div>
  );
};

export default Spinner;
